import Codes from "./AsxCompanyOptions";

export class AsxCompanyOptionsUtil {
    public static isCompanyOption(code: string): boolean {
        return Codes.includes(code);
    }
}